import { render, staticRenderFns } from "./TheAdminHistory.vue?vue&type=template&id=72839bc8"
import script from "./TheAdminHistory.vue?vue&type=script&lang=js"
export * from "./TheAdminHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports